export type Filter = {
  displayName: string;
  id: string;
  isActive: boolean;
  value: string;
  options: Array<FilterOption>;
};

export type FilterOption = {
  group: string;
  id: string;
  name: string;
  preselected: boolean;
};

export type ArticleState = {
  hasPremiumArticleEloquaForm: boolean;
  filters: Array<Filter>;
  appliedFilters: Array<FilterOption>;
  filterMappings: any;
  baseUrl: string;
  contentType: undefined;
};

export const initialState: ArticleState = {
  hasPremiumArticleEloquaForm: false,
  filters: [],
  appliedFilters: [],
  filterMappings: { filters: [] },
  baseUrl: '',
  contentType: undefined,
};
